import {
  createSlice,
  createEntityAdapter,
} from '@reduxjs/toolkit';
import { schema } from 'normalizr';

export const singleAttendeeActivityLogEntity = new schema.Entity('singleAttendeeActivityLog');

const singleAttendeeActivityLogAdapter = createEntityAdapter({
  sortComparer: (a: any, b: any) => b.action_at.toMillis() - a.action_at.toMillis(),
});

export const {
  selectAll: selectAllSingleAttendeeActivityLog,
} = singleAttendeeActivityLogAdapter.getSelectors((state: any) => state.singleAttendeeActivityLog);

export const selectFetchingSingleAttendeeActivityLog = (state) => state.singleAttendeeActivityLog.fetching;

export const singleAttendeeActivityLogSlice = createSlice({
  name: 'singleAttendeeActivityLog',
  initialState: singleAttendeeActivityLogAdapter.getInitialState({ fetching: true }),
  reducers: {
    upsertLogs(state, action) {
      singleAttendeeActivityLogAdapter.upsertMany(state, action.payload);
    },
    setFetching(state, action) {
      state.fetching = action.payload;
    },
  },
});

export const {
  upsertLogs,
  setFetching,
} = singleAttendeeActivityLogSlice.actions;

export default singleAttendeeActivityLogSlice.reducer;
